import logo from "../assets/logo.png";
import profile from "../assets/profile.jpg";
export default { logo, profile };
